<div class="offense" *ngIf="rows.length; else noLineup">
  <h3 class="offense__title">
    <span *ngIf="teamName" class="offense__team">{{ teamName }}</span>
    <span class="offense__title-label">Offense</span>
  </h3>
  <div class="offense__table-wrap" [class.offense__table-wrap--with-bench]="showBench && bench.length">
  <table class="offense__table" *ngIf="!showBench"
         [class.offense__table--running]="showBaseRunning">
    <thead>
    <tr>
      <th class="offense__col-num">#</th>
      <th class="offense__col-name">Player</th>
      <th class="offense__col-pos">Pos</th>
      <th *ngFor="let slot of inningSlots" [attr.colspan]="slot.count" class="offense__col-inning">
        {{ slot.inning }}
      </th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of rows" [class.offense__row--current]="row.isCurrentBatter">
      <td class="offense__num">
        <div *ngFor="let p of row.players" class="offense__stack-line">
          <span>{{ p.number || ' ' }}</span>
        </div>
      </td>
      <td class="offense__name">
        <div *ngFor="let p of row.players" class="offense__stack-line"
             [class.offense__stack-line--current]="p.isCurrentBatter">
          <span [title]="p.name">{{ p.name || ' ' }}</span>
        </div>
      </td>
      <td class="offense__pos">
        <div *ngFor="let p of row.players" class="offense__stack-line">
          <span>{{ p.position || ' ' }}</span>
        </div>
      </td>
      <td *ngFor="let pa of row.cells; let i = index" class="offense__cell"
          [class.offense__cell--sub-boundary]="row.cellSubBoundary[i]"
          [class.offense__cell--pitcher-boundary]="row.cellPitcherBoundary[i]">
        <ng-container *ngIf="pa; else emptyCell">
          <div class="offense__pa" [ngClass]="'offense__pa--' + pa.outcome"
               [class.offense__pa--retired]="showBaseRunning && pa.diamond?.reached === 0">
            <ng-container *ngIf="showBaseRunning && pa.diamond as d">
              <span class="offense__diamond" [class.offense__diamond--scored]="d.scored">
                <i class="offense__diamond-path"
                   [class.offense__diamond-path--first]="d.farthest >= 1"
                   [class.offense__diamond-path--second]="d.farthest >= 2"
                   [class.offense__diamond-path--third]="d.farthest >= 3"
                   [class.offense__diamond-path--home]="d.farthest >= 4"></i>
              </span>
              <b *ngFor="let corner of d.corners" class="offense__corner"
                 [class.offense__corner--out]="corner.out"
                 [class.offense__corner--long]="corner.label.length > 3"
                 [ngClass]="'offense__corner--' + corner.base">{{ corner.label }}</b>
              <b *ngIf="d.out" class="offense__out">{{ d.out.label || '&times;' }}</b>
            </ng-container>
            <span *ngIf="pa.pitches.length" class="offense__pitch-marks"
                  [title]="pitchTitle(pa.pitches)">
              <i *ngFor="let m of pa.pitches" class="offense__pitch-dot"
                 [ngClass]="'offense__pitch-dot--' + m.kind"></i>
            </span>
            <span class="offense__play"
                  [class.offense__play--long]="pa.play.length > 3">{{ pa.play }}</span>
            <span *ngIf="row.cellPitchCount[i] as pc" class="offense__pitch-count"
                  [title]="pc.pitches + ' pitches this inning, ' + pc.total + ' in the game'">
              {{ pc.pitches }}/{{ pc.total }}
            </span>
          </div>
        </ng-container>
        <ng-template #emptyCell>
          <div class="offense__pa offense__pa--empty"></div>
        </ng-template>
      </td>
    </tr>
    </tbody>
  </table>

  <table class="offense__table offense__table--compact" *ngIf="showBench"
         [class.offense__table--running]="showBaseRunning">
    <thead>
    <tr>
      <th class="offense__col-num">#</th>
      <th class="offense__col-name">Player</th>
      <th class="offense__col-pos">Pos</th>
      <th *ngFor="let _ of [].constructor(compressedColumnCount)" class="offense__col-inning"></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let row of compressedRows" [class.offense__row--current]="row.isCurrentBatter">
      <td class="offense__num">
        <div *ngFor="let p of row.players" class="offense__stack-line">
          <span>{{ p.number || ' ' }}</span>
        </div>
      </td>
      <td class="offense__name">
        <div *ngFor="let p of row.players" class="offense__stack-line"
             [class.offense__stack-line--current]="p.isCurrentBatter">
          <span [title]="p.name">{{ p.name || ' ' }}</span>
        </div>
      </td>
      <td class="offense__pos">
        <div *ngFor="let p of row.players" class="offense__stack-line">
          <span>{{ p.position || ' ' }}</span>
        </div>
      </td>
      <td *ngFor="let cell of row.cells" class="offense__cell"
          [class.offense__cell--sub-boundary]="cell.subBoundary"
          [class.offense__cell--pitcher-boundary]="cell.pitcherBoundary"
          [class.offense__cell--inning-end]="cell.inningEnd">
        <div class="offense__pa" [ngClass]="'offense__pa--' + cell.pa.outcome"
             [class.offense__pa--retired]="showBaseRunning && cell.pa.diamond?.reached === 0">
          <ng-container *ngIf="showBaseRunning && cell.pa.diamond as d">
            <span class="offense__diamond" [class.offense__diamond--scored]="d.scored">
              <i class="offense__diamond-path"
                 [class.offense__diamond-path--first]="d.farthest >= 1"
                 [class.offense__diamond-path--second]="d.farthest >= 2"
                 [class.offense__diamond-path--third]="d.farthest >= 3"
                 [class.offense__diamond-path--home]="d.farthest >= 4"></i>
            </span>
            <b *ngFor="let corner of d.corners" class="offense__corner"
               [class.offense__corner--out]="corner.out"
               [class.offense__corner--long]="corner.label.length > 3"
               [ngClass]="'offense__corner--' + corner.base">{{ corner.label }}</b>
            <b *ngIf="d.out" class="offense__out">{{ d.out.label || '&times;' }}</b>
          </ng-container>
          <span *ngIf="cell.inningStart" class="offense__inning-badge">{{ cell.inningStart }}</span>
          <span *ngIf="cell.pa.pitches.length" class="offense__pitch-marks"
                [title]="pitchTitle(cell.pa.pitches)">
            <i *ngFor="let m of cell.pa.pitches" class="offense__pitch-dot"
               [ngClass]="'offense__pitch-dot--' + m.kind"></i>
          </span>
          <span class="offense__play"
                [class.offense__play--long]="cell.pa.play.length > 3">{{ cell.pa.play }}</span>
          <span *ngIf="cell.pitchCount as pc" class="offense__pitch-count"
                [title]="pc.pitches + ' pitches this inning, ' + pc.total + ' in the game'">
            {{ pc.pitches }}/{{ pc.total }}
          </span>
        </div>
      </td>
      <td *ngFor="let _ of [].constructor(compressedColumnCount - row.cells.length)"
          class="offense__cell offense__cell--filler">
        <div class="offense__pa offense__pa--empty"></div>
      </td>
    </tr>
    </tbody>
  </table>

  <aside class="offense__bench" *ngIf="showBench && bench.length">
    <h4 class="offense__bench-title">Bench ({{ bench.length }})</h4>
    <ul class="offense__bench-list">
      <li *ngFor="let p of bench" class="offense__bench-item">
        <span class="offense__bench-num">{{ p.number || '—' }}</span>
        <span class="offense__bench-name">{{ p.name }}</span>
      </li>
    </ul>
  </aside>
  </div>

  <div class="offense__upcoming" *ngIf="upcomingBatters.length">
    <h4 class="offense__upcoming-title">
      {{ isTeamAtBat ? 'At bat & on deck' : 'Next half-inning' }}
    </h4>
    <div class="offense__upcoming-list">
      <div *ngFor="let b of upcomingBatters; let i = index"
           class="offense__upcoming-card"
           [class.offense__upcoming-card--current]="b.isCurrentBatter">
        <div class="offense__upcoming-name-row">
          <span class="offense__upcoming-num">{{ b.number || '—' }}</span>
          <span class="offense__upcoming-name">{{ b.player.name }}</span>
          <span class="offense__upcoming-pos" *ngIf="b.position">{{ b.position }}</span>
        </div>

        <div class="offense__upcoming-section" *ngIf="b.player.gameStats?.batting as gs">
          <h5 class="offense__upcoming-label">Game</h5>
          <div class="offense__upcoming-stats">
            <div class="offense__upcoming-stat"><span>AB</span><strong>{{ gs.ab ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>H</span><strong>{{ gs.h ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>R</span><strong>{{ gs.r ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>RBI</span><strong>{{ gs.rbi ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>HR</span><strong>{{ gs.hr ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>BB</span><strong>{{ gs.bb ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>HBP</span><strong>{{ gs.hbp ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>SB</span><strong>{{ gs.sb ?? 0 }}</strong></div>
          </div>
        </div>

        <div class="offense__upcoming-section" *ngIf="b.player.seasonStats?.batting as ss">
          <h5 class="offense__upcoming-label">Season</h5>
          <div class="offense__upcoming-stats">
            <div class="offense__upcoming-stat"><span>AVG</span><strong>{{ utilService.formatAvg(ss.ba) }}</strong></div>
            <div class="offense__upcoming-stat"><span>OBP</span><strong>{{ utilService.formatAvg(ss.obp) }}</strong></div>
            <div class="offense__upcoming-stat"><span>SLG</span><strong>{{ utilService.formatAvg(ss.sa) }}</strong></div>
            <div class="offense__upcoming-stat"><span>HR</span><strong>{{ ss.hr ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>RBI</span><strong>{{ ss.rbi ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>BB</span><strong>{{ ss.bb ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>SB</span><strong>{{ ss.sb ?? 0 }}</strong></div>
            <div class="offense__upcoming-stat"><span>AB</span><strong>{{ ss.ab ?? 0 }}</strong></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #noLineup>
  <div class="offense__empty">No lineup data yet.</div>
</ng-template>
